import { render, staticRenderFns } from "./YoutubePlayerComponent.vue?vue&type=template&id=4d0a2384&"
import script from "./YoutubePlayerComponent.vue?vue&type=script&lang=ts&"
export * from "./YoutubePlayerComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports